import React from "react";
import DivisionCmp from "../../../components/cards/DivisionCmp";
import { SectionModel } from "../../../models/components.model";
import { Address, DocumentUrl } from "../../../models/cartable.model";
import DetailInfoComponentThumbnail from "../../../components/detailInfo/detailInfoComponentThumbnail";

interface SchemaInfoModel {
  data?: Address;
  documentList: DocumentUrl[];
  withoutDoc: boolean;
}
function _PlaceInfo({ data, documentList, withoutDoc }: SchemaInfoModel) {
  const sections: SectionModel[] = [
    // { dataKey: "mobileNumber", rowCol: 3, title: " تلفن همراه" },
    // { dataKey: "phoneNumber", rowCol: 3, title: "تلفن ثابت", },
    { dataKey: "provinceTitle", rowCol: 3, title: " استان" },
    { dataKey: "cityTitle", rowCol: 3, title: " شهر" },
    { dataKey: "postalCode", rowCol: 3, title: " کدپستی" },
    { dataKey: "phoneNumber", rowCol: 3, title: " تلفن ثابت" },
    // { dataKey: "addressInfo", rowCol: 6, title: "آدرس" },
  ];
  return (
    <DetailInfoComponentThumbnail
      sections={sections}
      data={data}
      documentList={documentList}
      height={"20vh"}
      addressByInquiry={true}
      showFooter={false}
      showDoc={withoutDoc}
    />
  );
}

export default function PlaceInfo(props: any) {
  let documentUrlList = [] as DocumentUrl[];
  documentUrlList = props.data?.documentUrls;
  const child = (
    <>
      <_PlaceInfo
        data={props.data}
        documentList={documentUrlList}
        withoutDoc={props.withoutDoc}
      />
    </>
  );

  return (
    <>
      <DivisionCmp
        child={child}
        title={props.title ? props.title : "اظهارات متقاضی"}
      />
    </>
  );
}
